import { GraphService } from "../../../graphql/services/graph.service";
import { ToastService } from "../../../tools/message/service/toast.service";
import { ListItemRefModel } from "../../baseListing/models/list-item-ref.model";
import { TableRowMutator } from "../helpers/table-row-mutator";
import { TableComponent } from "../table.config";

export class TableRowRefModel extends ListItemRefModel {
  constructor(data: any, index: number, parent: TableComponent, graphService: GraphService, messageService: ToastService) {
    super(data, index, parent, graphService);
    this.mutator = new TableRowMutator(graphService, this, messageService);
  }

  /**
   * Returns the row data object.
   */
  getData(): any {
    return this.data?.[this.index];
  }

  /**
   * Returns specific information from the row data object.
   * @param key
   */
  get(key: string): any {
    return this.data?.[this.index]?.[key];
  }

  set(key: string, value: any) {
    this.parent.setItemValue(this.index, key, value);
    return this;
  }

  /**
   * removes a class from the row.
   * @param _class
   * @param commit
   */
  removeClass(_class: string, commit = true): void {
    this._action = { name: "removeClass", data: _class };
    if (commit) {
      return this.commit();
    }
    this.parent.removeItemClass(this.index, "item-loading");
  }
  /**
   * adds a class to the row.
   * @param _class
   * @param commit
   */
  addClass(_class: string, commit = true) {
    this._action = { name: "addClass", data: _class };
    if (commit) {
      return this.commit();
    }
    this.parent.addItemClass(this.index, "item-loading");
  }
  commit(): void {
    this.parent.removeItemClass(this.index, "item-loading");
    switch (this._action?.name) {
      case "remove":
        this.parent.removeItemClass(this.index, "to-remove");
        this.parent.removeItem(this.index);
        break;
      case "addClass":
        this.parent.addItemClass(this.index, this._action.data);
        break;
      case "removeClass":
        this.parent.removeItemClass(this.index, this._action.data);
        break;
      default:
        break;
    }
    this._action = undefined;
  }
}
